import support from '@assets/background/pa_bg_support.png';
import contacts from '@assets/background/pa_bg_contacts.svg';

export const backgrounds = {
  support,
  contacts,
};
